module.exports = __webpack_public_path__ + "static/media/Novia.25bc8f4c.webp";